import {map} from 'lodash';
import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';

import {ConfirmModal, Icon} from 'components';
import {ACTIVITY_NAME_TRANSLATE} from 'constants/session';
import {SessionActivityName} from 'interfaces';
import {TRANSLATION_KEYS} from 'locale';
import {getActivityIcon} from 'utils';

const T_KEYS = TRANSLATION_KEYS.IN_SESSION_PAGE.CONFLICTING_ACTIVITIES_MODAL;

type Props = {
    open: boolean;
    activity?: SessionActivityName;
    conflictingActivities?: SessionActivityName[];
    onClose: (confirmed: boolean, activity?: SessionActivityName) => void;
};

export const ConflictingActivitiesModal: React.FC<Props> = ({open, activity, conflictingActivities, onClose}: Props) => {
    const {t} = useTranslation();

    const getActivityInfo = useCallback((name: SessionActivityName) => name ? (
        <div key={name} className='tw-flex tw-items-center tw-my-2 tw-text-dark'>
            <Icon name={getActivityIcon(name)} className='tw-mr-2' />
            {t(ACTIVITY_NAME_TRANSLATE[name])}
        </div>
    ) : null, [t]);

    return (
        <ConfirmModal
            open={open}
            title={
                <div className='tw-flex tw-items-center'>
                    <Icon name='x-circle' color='alert' size='lg' className='tw-mr-1' />
                    {t(T_KEYS.TITLE)}
                </div>
            }
            fullWidth
            data={activity}
            maxWidth='xss'
            onClose={onClose}
        >
            <div className='tw-text-default'>{t(T_KEYS.ACTIVITY_START_LABEL)}</div>
            {getActivityInfo(activity)}
            <div className='tw-text-default tw-mt-4'>{t(T_KEYS.ACTIVITY_STOP_LABEL)}</div>
            {map(conflictingActivities, getActivityInfo)}
        </ConfirmModal>);
};
